import wx from "weixin-js-sdk"; // 引入wx
import request from "./request";
import { IWXResponse, IWXConfig } from "@/api/types";

/** *
 * 微信分享
 * @param shareTitle 分享标题
 * @param shareDesc 分享详情，摘要，简介
 * @param shareLink 分享的链接 会到redirect.html 中去重定向到分享页面
 * @param shareImgUrl 分享图片地址
 */
export function wxChatShare(
  shareTitle: string,
  shareDesc: string,
  shareLink: string,
  shareImgUrl: string
) {
  const _url = `//gatewayapi.cqliving.com/cqliving-boot-sso/weChat/jsapiSignature?weChatId=7&url=${encodeURIComponent(
    window.location.href.split("#")[0]
  )}`;

  request.get<any, IWXResponse>(_url).then(res => {
    const { code, data } = res;
    if (code >= 0) {
      const result: any = data;
      const config: IWXConfig = {
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印
        appId: result.wxAppId, // 必填，公众号的唯一标识
        timestamp: result.timestamp, // 必填，生成签名的时间戳
        nonceStr: result.nonceStr, // 必填，生成签名的随机串
        signature: result.signature, // 必填，签名
        jsApiList: [
          "onMenuShareAppMessage",
          "onMenuShareTimeline",
          "onMenuShareWeibo",
          "onMenuShareQZone"
        ]
      };
      wx.config(config);
      wx.ready(() => {
        // 分享到朋友圈
        wx.onMenuShareTimeline({
          title: shareTitle,
          link: shareLink,
          imgUrl: shareImgUrl
        });

        // 分享给朋友
        wx.onMenuShareAppMessage({
          title: shareTitle,
          desc: shareDesc,
          link: shareLink,
          imgUrl: shareImgUrl
        });

        // 分享到QQ
        wx.onMenuShareQQ({
          title: shareTitle,
          desc: shareDesc,
          link: shareLink,
          imgUrl: shareImgUrl
        });
      });
    }
  });
}
